"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Card(_a) {
    var event = _a.event;
    return react_1.default.createElement("a", { className: 'storybook-events-calender-card', href: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/videos/" + event.video.slug + "?external_id=" + event.external_id },
        react_1.default.createElement("div", null,
            react_1.default.createElement("img", { src: event.thumbnail, className: 'rounded-lg w-5/12 lg:w-1/3' }),
            react_1.default.createElement("div", { className: 'flex flex-col justify-center gap-2 px-2' },
                react_1.default.createElement(storybook_1.Texts.Primary, { className: 'storybook-events-card-description' }, event.title),
                react_1.default.createElement("span", { className: 'text-gray-500 text-sm' }, event.start_label))));
}
exports.default = Card;
